export default "__VITE_ASSET__BQEaZFfM__"